import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import pt from './locales/pt.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import bg from './locales/bg.json';

export const languages = [
  { code: 'bg', name: 'Български', flag: '🇧🇬', iso2: 'BG' },
  { code: 'en', name: 'English', flag: '🇬🇧', iso2: 'GB' },
  { code: 'es', name: 'Español', flag: '🇪🇸', iso2: 'ES' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', iso2: 'FR' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹', iso2: 'IT' },
  { code: 'pt', name: 'Português', flag: '🇵🇹', iso2: 'PT' },
] as const;

export type LanguageCode = typeof languages[number]['code'];

export const STORAGE_KEY = 'paynovus_language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: pt },
      es: { translation: es },
      fr: { translation: fr },
      it: { translation: it },
      bg: { translation: bg },
    },
    fallbackLng: 'en',
    detection: {
      // Only look at localStorage for manual selections, don't use navigator
      // IP-based detection will handle automatic language selection
      order: ['localStorage'],
      lookupLocalStorage: STORAGE_KEY,
      // Don't auto-cache - only manual selections should be cached
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
